import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "withdrawals-page" }
const _hoisted_2 = { class: "mb-5 flex flex-wrap items-center justify-between gap-4" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "flex h-11 w-11 items-center justify-center rounded-xl bg-indigo-50 text-indigo-700" }
const _hoisted_5 = { class: "rounded-2xl border border-slate-200 bg-white p-3 shadow-sm sm:p-5" }
const _hoisted_6 = {
  key: 0,
  class: "grid grid-cols-1 gap-y-4",
  role: "status"
}
const _hoisted_7 = {
  key: 1,
  class: "overflow-x-auto"
}
const _hoisted_8 = {
  key: 0,
  class: "py-12 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_IpgTransactionSkelton = _resolveComponent("IpgTransactionSkelton")!
  const _component_WithdrawalsTableComponent = _resolveComponent("WithdrawalsTableComponent")!
  const _component_CustomPaginationComponent = _resolveComponent("CustomPaginationComponent")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_v_icon, { size: "22" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("mdi-bank-transfer-out", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "text-xl font-bold text-slate-900" }, "درخواست‌های تسویه"),
          _createElementVNode("p", { class: "mt-1 text-sm text-slate-500" }, "بررسی و پیگیری برداشت‌های کاربران")
        ], -1))
      ]),
      _createVNode(_component_v_btn, {
        color: "primary",
        variant: "tonal",
        rounded: "lg",
        "prepend-icon": "mdi-arrow-right",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode(" بازگشت ", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.getLoadingPanel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (index) => {
              return _createVNode(_component_IpgTransactionSkelton, { key: index })
            }), 64))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_WithdrawalsTableComponent, { transactions: _ctx.getAllWithdrawals }, null, 8, ["transactions"]),
            (!_ctx.getAllWithdrawals.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_v_icon, {
                    size: "34",
                    class: "text-slate-300"
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("mdi-inbox-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[6] || (_cache[6] = _createElementVNode("p", { class: "mt-2 text-sm text-slate-500" }, "درخواستی برای نمایش وجود ندارد.", -1))
                ]))
              : _createCommentVNode("", true),
            (Number(_ctx.getGlobalPagination.total) > Number(_ctx.getGlobalPagination.limit))
              ? (_openBlock(), _createBlock(_component_CustomPaginationComponent, {
                  key: 1,
                  "total-items": _ctx.getGlobalPagination.total,
                  "items-per-page": 50,
                  onPageChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handelPagination()))
                }, null, 8, ["total-items"]))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}